export const stringSort = (a: string, b: string) => a > b ? 1 : a < b ? -1 : 0;
